module.exports = __webpack_public_path__ + "img/react.03dc9fec.png";